/**
 * Auth-Store (Modul-State, kein React-Context) — Token-Provider und Re-Login-/
 * Logout-Handler, registriert vom AuthProvider (Muster apps/stammdaten, ohne Logto).
 *
 * src/lib/api.ts nutzt getAccessToken() als Axios-Request-Interceptor.
 */

export const AUTH_MODE: "dev" | "authentik" =
  import.meta.env.VITE_AUTH_MODE === "dev" ? "dev" : "authentik"

type TokenProvider = () => Promise<string | null>
type Aktion = () => void | Promise<void>

let _tokenProvider: TokenProvider | null = null
let _relogin: Aktion | null = null
let _reloginVersucht = false

export function setTokenProvider(provider: TokenProvider | null): void {
  _tokenProvider = provider
}

export async function getAccessToken(): Promise<string | null> {
  if (!_tokenProvider) return null
  try {
    return await _tokenProvider()
  } catch {
    return null
  }
}

export function setReloginHandler(handler: Aktion | null): void {
  _relogin = handler
}

/** 401 vom Backend: genau EIN Re-Login-Versuch je Seitenaufruf (keine Redirect-Schleife). */
export function triggerRelogin(): void {
  if (AUTH_MODE === "dev" || _reloginVersucht || !_relogin) return
  _reloginVersucht = true
  void _relogin()
}
